/**
 * AMCレポートタイプ
 */
const AMC_REPORT_TYPE = {
    7: '注文率リフト',
    8: 'リーチフリクエンシー',
    9: 'リーチカバレッジ',
    10: '自社ECユーザー分析',
    11: 'コンバージョンイベント', // アフィニティ分析
    12: 'フリークエンシー別パフォーマンス',
    13: '自社ECユーザー', // アフィニティ分析
}

export default AMC_REPORT_TYPE